import { H6, SmallText } from 'app/common/typography'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { colors } from 'shared/assets/styles'
import { formatDateToDisplay } from 'shared/utils'
import styled from 'styled-components'

const { grey } = colors

type Props = {
    endDate: Date
}

const BlazonExpiration = (props: Props) => {
    const { endDate } = props

    return (
        <Root>
            <H6>
                <FormattedMessage id="kingdom.challenge.expiration.title" />
            </H6>
            <Description>
                <FormattedMessage
                    id="kingdom.blazon.expiration.date"
                    values={{
                        expirationDate: formatDateToDisplay(new Date(endDate))
                    }}
                />
            </Description>
        </Root>
    )
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const Description = styled(SmallText)`
    white-space: pre-line;
    color: ${grey};
`

export default BlazonExpiration
